import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { formatDateTime } from '../../js/utils'
import "../../css/audit-log-table.css";

const propertiesToExclude = [ 'IsCompositeKey', 'PrimaryKeyFields', 'PKEntityFieldName', 'Password',
  'PKSequenceName', 'PKDatabaseField', 'PK', 'ModifiedDate', 'ModifiedByUser', 'CreatedDate', 'CreatedByUser' ]

const ExpandedRowTemplate = rowData => {
  let auditData = JSON.parse(rowData['AuditData'])
  let auditDataProperties = Object.getOwnPropertyNames(auditData)
    .filter(propertyName => !propertiesToExclude.some(excludeProperty => excludeProperty === propertyName))
  return (
    <div className={"p-grid"}>
      {auditDataProperties.map(propertyName => {
        let propertyValue = String(auditData[propertyName])
        return (
          <React.Fragment key={propertyName}>
            <div className={"p-col-6"}>
              {propertyName}
            </div>
            <div className={"p-col-6"}>
              {propertyValue}
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}

const AuditDateTemplate = rowData => {
  return <span>{formatDateTime(rowData['AuditDate'])}</span>;
}

const AuditLogTable = ({ auditLogEntries, expandedRows, rowToggled }) => {
  return (
    <DataTable value={auditLogEntries} className={'audit-log-table'} expandedRows={expandedRows} paginator={true}
      rows={10} rowsPerPageOptions={[10,20,50]}
      onRowToggle={rowToggled} rowExpansionTemplate={ExpandedRowTemplate} responsive={true} >
      <Column expander={true} className="td-expanderSection" />
      <Column field="AuditDate" header="Date/time" body={AuditDateTemplate} sortable={true} filter={true}  filterMatchMode="contains"/>
      <Column field="AuditUsername" header="Username" sortable={true} filter={true} filterMatchMode="contains" />
      <Column field="TypeName" header="Type" sortable={true} filter={true} filterMatchMode="contains"/>
      <Column field="Action" header="Action" sortable={true} filter={true} filterMatchMode="contains"/>
      <Column field="PrimaryId" header="Identifier" sortable={true} filter={true} filterMatchMode="contains"/>
      <Column field="Candidate" header="Candidate" sortable={true} filter={true} filterMatchMode="contains"/>
    </DataTable>
  )
}

export default AuditLogTable



// WEBPACK FOOTER //
// ./src/components/audit-log/audit-log-table.js